<template>
  <div
    ref="LlPaginateList"
    class="ll-paginate-list"
    :class="{'no-border-top': isCardLayout}"
  >
    <div
      v-if="!isloading"
      class="list-content"
    >
      <slot />
    </div>
    <DotLoading
      v-if="isloading"
      primary
    />
    <div
      v-if="!isloading"
      class="paginate-wrap"
    >
      <div class="paginate-wrap__left">
        <span>
          {{ _currentLocale === 'ja' ? '' : $t('前往頁數') }}
          <StateInputButton
            type="number"
            :value="enterPage"
            @input="$_getEnterPage($event)"
            @enter="$_paginatePage($event)"
          />
          {{ _currentLocale === 'ja' ? $t('前往頁數') : '' }}
        </span>
        <span>{{ $t('共{number}頁',{number:pageCount}) }}</span>
        <WsButton001
          short-button
          @click="$_paginatePage(enterPage)"
        >
          {{ $t('前往') }}
        </WsButton001>
      </div>
      <div class="paginate-wrap__right">
        <span>{{ _dataCount }} </span>
        <div class="paginate-wrap__right__paginate">
          <paginate
            :page-count="pageCount"
            :page-range="pageRange"
            :margin-pages="marginPages"
            :first-button-text="firstButtonText"
            :last-button-text="lastButtonText"
            :prev-text="prevText"
            :next-text="nextText"
            :container-class="containerClass"
            :first-last-button="firstLastButton"
            :value="page"
            @input="$_paginatePage($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlPaginateList",
  props: {
    isloading: {
      type: Boolean,
      default: false,
    },
    pageCount: {
      type: Number,
      default: 0,
    },
    pageRange: {
      type: Number,
      default: 0,
    },
    marginPages: {
      type: Number,
      default: 3,
    },
    firstButtonText: {
      type: String,
      default: "",
    },
    lastButtonText: {
      type: String,
      default: "",
    },
    prevText: {
      type: String,
      default: "",
    },
    nextText: {
      type: String,
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
    firstLastButton: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 0,
    },
    fromDataNum: {
      type: Number,
      default: 0,
    },
    toDataNum: {
      type: Number,
      default: 0,
    },
    totalDataNum: {
      type: Number,
      default: 0,
    },
    mobileCardLayoutEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      enterPage: 0,
      isTooWidth: true,
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.screenWidth < 768;
    },
    isCardLayout() {
      return this.mobileCardLayoutEnabled && this.isMobile;
    },
    _dataCount() {
      return this.$t("第{fromNum}-{toNum}筆 共{totalNum}筆", {
        fromNum: this.fromDataNum,
        toNum: this.toDataNum,
        totalNum: this.totalDataNum,
      });
    },
    _currentLocale() {
      return this.$store.state.stone_locale.selectingLocale.code;
    }
  },
  watch: {
    page: {
      handler() {
        this.enterPage = this.page;
      },
      immediate: true,
    },
  },
  mounted() {
    this.enterPage = this.page;
    window.addEventListener('resize', this.$_handleResize);

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_handleResize);
  },
  methods: {
    $_paginatePage($event) {
      if (typeof Number($event) !== "number") return;
      if (Number($event) > this.pageCount) {
        this.enterPage = this.page;
        this.$emit("input", this.page);
      } else {
        this.$emit("input", Number($event));
      }
    },
    $_getEnterPage($event) {
      this.enterPage = $event;
    },
    $_handleResize() {
      this.screenWidth = window.innerWidth;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-paginate-list";
</style>